// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 2H22V22L2 22V2ZM13 6.5H11V11L6.5 11V13L11 13V17.5H13V13H17.5V11H13V6.5Z"}}]};

const AddRectangleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'add-rectangle-filled',
    ref,
    icon: element,
  },
));

AddRectangleFilledIcon.displayName = 'AddRectangleFilledIcon';

export default AddRectangleFilledIcon;
